<template>

    <b-row>

        <b-col>

            <b-card header="Extract-My-Data"
                header-bg-variant="info"
                header-text-variant="white"
            >

                <b-row>

                    <b-col lg="9" sm="9" xs="12">

                        <p>Your data is personal & important, and we believe that you should have access to it for whatever reason you'd like. {{ userDataString }}</p>
                        <h3 class="mb-4 text-danger">**The download process can take up to a few minutes depending on the size of the data, please do not close out the browser until you receive a response</h3>

                        <b-button variant="info" size="sm" @click=" pullShifts() ">Download Shift History</b-button>
                        <b-button v-if=" isClient " variant="info" size="sm" @click=" pullInvoices() ">Download Invoice History</b-button>
                    </b-col>
                </b-row>

            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import UsesRole from '../mixins/UsesRole';

    export default {

        mixins: [ UsesRole ],
        props: {

            user : Object
        },
        computed : {

            userDataString(){

                let string = '';
                if( this.isClient ) string = 'The buttons below will provide you with all of your Shift History and Invoices';
                else string = 'The button below will provide you with all of your Shift History';

                return string;
            }
        },
        methods: {

            pullShifts(){

                window.open( '/profile/data-pull-shifts', '_blank' );
            },
            pullInvoices(){

                if( this.isClient ) window.open( '/profile/data-pull-invoices', '_blank' );
                else alerts.addMessage( 'danger', 'Unable to download invoices, incorrect permissions!' );
            }
        }
    }
</script>

<style>

</style>